import {configPath, logsPath, mainPath, pagePath, userPath} from '../../app-routing.constants';
import {ApiList} from '../../API/api-list.enum';
import {profilePath} from '../../user/user-routing.module';
import {LogsPaths} from '../../logs/logs-paths.enum';
import {ConfigPaths} from '../../../../projects/admin/config/config-paths.enum';
import {EveryMinuteInMsTimer$} from './everyMinute.observable';
import {map} from 'rxjs/operators';
/*import {MENU_AIM} from "@angular/cdk/menu";*/

const angularMainPath = `/${mainPath}`;

const gettext = (a) => a;

export const RERORT_MENU_ID = 'report_menu';


function searchTree(element, id){
  if(element.id == id){
    return element;
  }else if (Array.isArray(element.children)){
    let i;
    let result = null;
    for(i=0; result == null && i < element.children.length; i++){
      result = searchTree(element.children[i], id);
    }
    return result;
  }
  return null;
}

const mergeMenus = (...menuLists) => {
  let resultMenu = [];

  const findMenuById= (id: number) => {
    for(let m of resultMenu) {
      const tmpMenu = searchTree(m, id);
      if (tmpMenu) {
        return tmpMenu;
      }
    }
    return null;
  };

  menuLists.forEach(menu => {
    menu.forEach(m => {
      const lvl1 = findMenuById(m.id);
      if (!lvl1) {
        resultMenu.push(m);
        return;
      }
      if (Array.isArray(m.children)) {
        const uniqChildren = m.children.filter(child => !lvl1.children.find(lvl1Child => lvl1Child.id === child.id));
        lvl1.children = [...lvl1.children, ...uniqChildren];
      }
    });
  });
  return resultMenu;
};
export const createMenu = (user_id) => (
  mergeMenus(
    createGlobalMenu(user_id, 'semux'),
    createGlobalMenu(user_id, 'app', `/app/${mainPath}`),
    createGlobalMenu(user_id, 'admin', `/admin/${mainPath}`)
  ).sort((a, b) => a.id > b.id ? 1 : -1)
);



export const createGlobalMenu = (user_id, namespace?: string, localMainPath = angularMainPath) => (
  [
    {
      id: 2,
      namespaces: ['app'],
      path: [localMainPath],
      template: RERORT_MENU_ID
    },
    {
      id: 1,
      namespaces: ['app'],
      iconCss: 'svg apps',
      title: gettext('MENU.APPLICATIONS'),
      children: [
        {
          id: 11,
          namespaces: ['app'],
          pathArray: [localMainPath, 'dashboard'],
          title: gettext('Dashboard'),
          iconCss: 'in in-dashboard-rounded',
          apiList: [ApiList.ExDashboard],
          caption: 'CAPTION.DASHBOARDS',
          visible: true,
        },
        {
          id: 12,
          namespaces: ['app'],
          iconCss: 'in in-event-note',
          title: gettext('Event Log'),
          pathArray: [localMainPath, 'eventslog'],
          apiList: [ApiList.EventLog],
          caption: 'CAPTION.EVENTLOG',
          visible: true,
        },
        {
          id: 13,
          namespaces: ['app'],
          pathArray: [localMainPath, 'charts'],
          title: gettext('Charts'),
          iconCss: 'in in-chart-line',
          apiList: [ApiList.ParamTag],
          caption: 'CAPTION.CHARTS',
          visible: true,
        },
        {
          id: 14,
          namespaces: ['app'],
          pathArray: [localMainPath, 'map'],
          title: gettext('Objects'),
          iconCss: 'in in-globe',
          apiList: [ApiList.ParamTag],
          caption: 'CAPTION.MAP',
          visible: true
        },
        {
          id: 15,
          namespaces: ['app'],
          pathArray: [localMainPath, 'fuxa'],
          title: gettext('Fuxa'),
          iconCss: 'in in-cpu',
          apiList: [ApiList.ParamTag],
          caption: 'CAPTION.FUXA',
          visible: true
        },
      ]
    },
// -----------------------------------------------------------------------------------
    {
      // iconCss: 'fa fa-tags',
      id: 3,
      namespaces: ['admin'],
      iconCss: 'svg etlSetup',
      title: gettext('MENU.ETLSETUP'),
      children: [
        {
          id: 31,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'paramtag'],
          apiList: [ApiList.ParamTag],
          title: gettext('MENU.PARAMTAGS'),
          iconCss: 'in in-tag',
          minPrivilegy: 'update',
          caption: 'CAPTION.PARAMTAG',
          visible: true,
        },
        {
          id: 32,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'businessparams'],
          title: gettext('MENU.BUSINESS_PARAMS'),
          apiList: [ApiList.businessparam],
          minPrivilegy: 'update',
          iconCss: 'in in-parameter',
          caption: 'CAPTION.BUSINESSPARAMS',
          visible: true
        },
        {
          id: 33,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'businessevents'],
          apiList: [ApiList.eventdwh],
          minPrivilegy: 'update',
          title: gettext('MENU.BUSINESS_EVENTS'),
          iconCss: 'in in-event',
          visible: true
        },
        {
          id: 34,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'businessdwh'],
          minPrivilegy: 'update',
          apiList: [ApiList.dwh],
          title: gettext('MENU.DWH'),
          iconCss: 'in in-export-setup',
          caption: 'CAPTION.BUSINESSDWH',
          visible: true
        },
        {
          id: 35,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.businessParamFailureLog],
          apiList: [ApiList.BusinessParamFailureLog],
          title: gettext('LOGS.BUSINESS_PARAMS_LOG.HEADER'),
          iconCss: 'in in-export-errors',
        },
      ]
    },
// -----------------------------------------------------------------------------------
    {
      id: 4,
      namespaces: ['admin'],
      title: 'MENU.OBJECTS',
      iconCss: 'svg objects',
      children: [
        {
          id: 41,
          namespaces: ['admin'],
          iconCss: 'in in-university',
          title: gettext('Objects'),
          pathArray: [localMainPath, pagePath, 'object'],
          minPrivilegy: 'update',
          apiList: [ApiList.Object],
        },
        {
          id: 42,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'controllersmanagement'],
          apiList: [ApiList.ControllersManagement],
          title: gettext('Controllers management'),
          iconCss: 'in in-cpu-settings'
        },
        {
          id: 43,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'drone'],
          apiList: [ApiList.ControllersManagement],
          title: gettext('Drones'),
          iconCss: 'in in-router'
        },

      ]
    },
// -----------------------------------------------------------------------------------
    {
      id: 5,
      iconCss: 'svg configurations',
      title: gettext('Configurations'),
      namespaces: ['admin', 'app'],
      children: [
        {
          id: 51,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'typicalconfig'],
          apiList: [ApiList.TypicalConfig],
          minPrivilegy: 'create',
          title: gettext('TypicalConfigs'),
          iconCss: 'in in-tune',
          visible: true,
        },
        {
          id: 52,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'controlprocedure'],
          apiList: [ApiList.ControlProcedure, ApiList.ProcCondition],
          minPrivilegy: 'create',
          title: gettext('ControlProcedures'),
          iconCss: 'in in-arrow-range',
          visible: true,
        },
        {
          id: 53,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'event'],
          minPrivilegy: 'update',
          apiList: [ApiList.Event],
          title: gettext('Events'),
          iconCss: 'in in-list',
          visible: true,
        },
        {
          id: 54,
          namespaces: ['admin'],
          groupLine: true,
          pathArray: [localMainPath, pagePath, 'paramstates'],
          minPrivilegy: 'update',
          apiList: [ApiList.paramstate],
          title: gettext('ParamStates'),
          iconCss: 'in in-list-status',
          visible: true,
        },
        {
          id: 55,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'scheduletemplate'],
          apiList: [ApiList.Scheduletemplate],
          minPrivilegy: 'create',
          title: gettext('ScheduleTemplate'),
          iconCss: 'in in-calendar-clock',
          visible: true,
        },
        {
          id: 56,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'zone'],
          apiList: [ApiList.Zone],
          minPrivilegy: 'create',
          title: gettext('Zones'),
          iconCss: 'in in-activity-zone',
          visible: true,
        },
        {
          id: 57,
          namespaces: ['app'],
          pathArray: [localMainPath, 'geo', 'geozones'],
          apiList: [ApiList.GeoZone],
          minPrivilegy: 'create',
          title: gettext('Geozones'),
          iconCss: 'in in-selection-marker',
          visible: true,
        },
        {
          id: 58,
          namespaces: ['admin'],
          pathArray: [localMainPath, configPath, ConfigPaths.importPath],
          apiList: [ApiList.Device, ApiList.TypicalConfig],
          minPrivilegy: 'create',
          title: gettext('MENU.IMPORT'),
          iconCss: 'in in-import',
          visible: true,
        },
        {
          id: 59,
          namespaces: ['admin'],
          pathArray: [localMainPath, configPath, ConfigPaths.exportPath],
          apiList: [ApiList.Device, ApiList.TypicalConfig],
          minPrivilegy: 'create',
          title: gettext('MENU.EXPORT'),
          iconCss: 'in in-export',
          visible: true,
        },
        {
          id: 501,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'globalrule'],
          apiList: [ApiList.Device, ApiList.GlobalRule],
          minPrivilegy: 'create',
          title: gettext('GlobalRules'),
          iconCss: 'fa fa-archive',
          visible: true,
        },
      ]
    },
    {
      id: 6,
      namespaces: ['admin'],
      iconCss: 'svg devices',
      title: gettext('Devices'),
      children: [
        {
          id: 61,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'device'],
          apiList: [ApiList.Device],
          minPrivilegy: 'create',
          title: gettext('Devices'),
          iconCss: 'in in-home-iot-device',
          visible: true,
        },
        {
          id: 62,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'controllermodel'],
          apiList: [ApiList.ControllerModel],
          minPrivilegy: 'create',
          title: gettext('Controller model'),
          iconCss: 'in in-cpu',
          visible: true,
        },
        {
          id: 63,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'deviceclassifier'],
          minPrivilegy: 'update',
          apiList: [ApiList.DeviceClassifier],
          title: gettext('Device classifier'),
          iconCss: 'in in-file-tree',
          visible: true,
        },
        {
          id: 64,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'portsinfo'],
          minPrivilegy: 'update',
          apiList: [ApiList.Port],
          title: gettext('MENU.PORTINFO'),
          iconCss: 'in in-ethernet',
          visible: true,
        },
      ]
    },
    {
      id: 7,
      namespaces: ['admin'],
      title: gettext('MENU.MEDIA'),
      iconCss: 'svg media',
      children: [
        {
          id: 71,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'iconset'],
          minPrivilegy: 'update',
          apiList: [ApiList.IconSet, ApiList.Icon],
          title: gettext('iconMenuName'),
          iconCss: 'in in-baseline-folder-special',
          visible: true,
        },
        {
          id: 72,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'imageset'],
          minPrivilegy: 'update',
          apiList: [ApiList.IconSet, ApiList.Icon],
          title: gettext('MENU.IMAGES'),
          iconCss: 'in in-image-multiple',
          visible: true,
        },
        {
          id: 73,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'branding'],
          minPrivilegy: 'update',
          apiList: [ApiList.Contact, ApiList.Branding],
          title: gettext('Rebranding'),
          iconCss: 'in in-baseline-brush',
          visible: true,
        },
      ]
    },

    {
      id: 8,
      namespaces: ['admin'],
      title: gettext('MENU.REFBOOKS'),
      iconCss: 'svg refBooks',
      children: [
        {
          id: 81,
          namespaces: ['admin'],
          groupCss: {position: 'relative', top: '3px'},
          pathArray: [localMainPath, pagePath, 'paramcategory'],
          minPrivilegy: 'update',
          apiList: [ApiList.ParamCategory],
          title: gettext('Categories'),
          iconCss: 'in in-temperature-celsius',
          visible: true,
        },
        {
          id: 82,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'objecttype'],
          minPrivilegy: 'update',
          apiList: [ApiList.ObjectType],
          title: gettext('Objects classifier'),
          iconCss: 'in in-office-building-marker',
          visible: true,
        },
        {
          id: 83,
          namespaces: ['admin'],
          groupCss: {position: 'relative', top: '3x'},
          pathArray: [localMainPath, pagePath, 'extattr'],
          minPrivilegy: 'update',
          apiList: [ApiList.Attr],
          title: gettext('Attrs'),
          iconCss: 'in in-baseline-edit-attributes'
        },
        {
          id: 84,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'calendar'],
          minPrivilegy: 'update',
          apiList: [ApiList.Calendar],
          title: gettext('CalendarTemplate'),
          iconCss: 'in in-calendar-multiple',
        },
        {
          id: 87,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'sensorlocation'],
          minPrivilegy: 'update',
          apiList: [ApiList.Sensorlocation],
          title: gettext('Room type'),
          iconCss: 'in in-baseline-lock',
        },
        {
          id: 88,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'objectstate'],
          minPrivilegy: 'update',
          apiList: [ApiList.ObjectState],
          title: gettext('Object states'),
          iconCss: 'fa fa-bookmark',
        },
        {
          id: 89,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'predefinedparam'],
          apiList: [ApiList.PredefinedParam],
          minPrivilegy: 'create',
          title: gettext('Predefinedparams'),
          iconCss: 'fa fa-retweet',
          visible: true,
        },
      ]
    },
    {
      id: 9,
      namespaces: ['admin'],
      iconCss: 'svg logFiles',
      title: gettext('Log Files'),
      children: [
        {
          id: 91,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.commandLog],
          title: gettext('Command log'),
          iconCss: 'in in-commands-log',
          queryParams$: EveryMinuteInMsTimer$.pipe(map(timestamp => ({to: timestamp, from: (timestamp - 2505600000)}))),
          apiList: [ApiList.CommandLog],
          visible: true,
        },
        {
          id: 92,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.setValueLog],
          queryParams$: EveryMinuteInMsTimer$.pipe(map(timestamp => ({to: timestamp, from: (timestamp - 2505600000)}))),
          apiList: [ApiList.SetValueLog],
          title: gettext('Set Value Log'),
          iconCss: 'in in-setvalue-log',
          visible: true,
        },
        {
          id: 96,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.userActivityLog],
          queryParams$: EveryMinuteInMsTimer$.pipe(map(timestamp => ({
            user: [user_id],
            to: timestamp,
            from: (timestamp - 2505600000)
          }))),
          apiList: [ApiList.UserActivityLog],
          title: gettext('User activity log'),
          iconCss: 'in in-setvalue-log',
          visible: true,
        },
        {
          id: 93,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.eventLog],
          /*TODO: расшарить EveryMinuteInMsTimer$ между ссылками*/
          queryParams$: EveryMinuteInMsTimer$.pipe(map(timestamp => ({to: timestamp, from: (timestamp - 2505600000)}))),
          apiList: [ApiList.EventLog],
          title: gettext('Event log'),
          iconCss: 'in in-event-note-outline',
        },
        {
          id: 94,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.notifyLog],
          queryParams$: EveryMinuteInMsTimer$.pipe(map(timestamp => ({
            to: timestamp,
            from: (timestamp - 2505600000),
            user: user_id
          }))),
          apiList: [ApiList.NotifyLog],
          title: gettext('LOGS.NOTIFY_LOG.HEADER'),
          iconCss: 'in in-notifications-log',
        },
        {
          id: 95,
          namespaces: ['admin'],
          pathArray: [localMainPath, logsPath, LogsPaths.adminLog],
          queryParams$: EveryMinuteInMsTimer$.pipe(map(timestamp => ({to: timestamp, from: (timestamp - 2505600000)}))),
          apiList: [ApiList.AdminLog],
          title: gettext('Admin log'),
          iconCss: 'in in-system-log',
        },

      ],
    },

    {
      id: 10,
      namespaces: ['admin'],
      iconCss: 'svg systemAccess',
      title: gettext('MENU.SYSTEMACCESS'),
      children: [
        {
          id: 101,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'user'],
          apiList: [ApiList.SysUser],
          title: gettext('Users'),
          iconCss: 'in in-users',
          visible: true,
        },
        {
          id: 102,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'usergroup'],
          apiList: [ApiList.UserGroup],
          title: gettext('UserGroups'),
          iconCss: 'in in-user-group',
          visible: true,
        },
        {
          id: 103,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'userrole'],
          apiList: [ApiList.SDirRole],
          title: gettext('Roles'),
          iconCss: 'in in-baseline-admin-panel-settings',
          visible: true,
        },
        {
          id: 104,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'oauth2'],
          apiList: [ApiList.OAuth2],
          title: gettext('OAUTH2.PROVIDERS'),
          iconCss: 'in in-user-service',
          visible: true,
        },
      ],
    },
    {
      id: 20,
      namespaces: ['admin'],
      title: gettext('Server'),
      iconCss: 'svg server',
      children: [
        {
          id: 201,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'collectorserver'],
          minPrivilegy: 'update',
          apiList: [ApiList.CollectorServer],
          title: gettext('Collector Server'),
          iconCss: 'in in-cluster-solid',
        },
        /*{
          id: 202,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'chirpstackserver'],
          minPrivilegy: 'update',
          apiList: [ApiList.ChirpstackServer],
          title: gettext('ChirpstackServer'),
          iconCss: 'in in-chirpstack',
        },*/
        {
          id: 204,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'notificationserver'],
          minPrivilegy: 'read',
          apiList: [ApiList.NotificationServer],
          title: gettext('Notification Server'),
          iconCss: 'in in-circle-notifications',
        },
        {
          id: 206,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'companies'],
          minPrivilegy: 'create',
          apiLists: [[ApiList.Company], [ApiList.UserCompany]],
          title: gettext('Companies'),
          iconCss: 'in in-company',
        },
        {
          id: 208,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'hierarchy'],
          apiList: [ApiList.ControllersManagement],
          title: gettext('Instance Master'),
          iconCss: 'in in-router'
        },
      ]
    },
    {
      id: 16,
      namespaces: ['admin'],
      title: 'Extsystems Menu',
      iconCss: 'svg extSystems',
      children: [
        {
          id: 203,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'pbxserver'],
          minPrivilegy: 'update',
          apiList: [ApiList.PbxServer],
          title: gettext('PbxServer'),
          iconCss: 'fa fa-phone',
        },
        {
          id: 205,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'extsystem'],
          minPrivilegy: 'update',
          apiList: [ApiList.ExtSystem],
          title: gettext('Extsystems'),
          iconCss: 'fa fa-cloud-upload',
        },
        {
          id: 207,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'applications'],
          minPrivilegy: 'create',
          apiLists: [[ApiList.Application]],
          title: gettext('Applications'),
          iconCss: 'in in-company',
        },
        {
          id: 209,
          namespaces: ['admin'],
          pathArray: [localMainPath, pagePath, 'dataprovider'],
          minPrivilegy: 'update',
          apiList: [ApiList.ExtSystem],
          title: gettext('Dataproviders'),
          iconCss: 'fa fa-cloud-download',
        },
      ]
    },
    {
      id: 30,
      namespaces: ['admin'],
      iconCss: 'svg mainStore',
      title: gettext('MENU_STORE.MAIN'),
      apiList: [ApiList.ExWidget],
      children: [
        {
          id: 301,
          namespaces: ['admin'],
          pathArray: [localMainPath, 'store'],
          apiList: [ApiList.ExWidget],
          // visibility: `sysuser`,
          minPrivilegy: 'update',
          title: gettext('MENU_STORE.LIST'),
          iconCss: 'in in-widgets-outline',
        },
        {
          id: 302,
          namespaces: ['admin'],
          pathArray: [localMainPath, 'store', 'my'],
          apiList: [ApiList.ExWidget],
          minPrivilegy: 'update',
          // visibility: `sysuser`,
          title: gettext('MENU_STORE.MY'),
          iconCss: 'in in-widgets',
        },
      ],
    },
    {
      id: 40,
      namespaces: ['admin', 'semux', 'app'],
      iconCss: 'svg userSettings',
      title: gettext('MENU.USER_SETTINGS'),
      children: [
        {
          id: 401,
          namespaces: ['admin', 'semux', 'app'],
          pathArray: [localMainPath, userPath, profilePath],
          title: gettext('MENU.PROFILE'),
          iconCss: 'in in-account',
          visible: true
          /*apiList: [ApiList.ExDashboard]*/
        },
        {
          id: 402,
          namespaces: ['admin', 'semux', 'app'],
          pathArray: [localMainPath, pagePath, 'profilesubscription'],
          title: gettext('UserSubscription'),
          iconCss: 'in in-checklist',
        },
        {
          id: 403,
          namespaces: ['admin', 'semux', 'app'],
          pathArray: [localMainPath, pagePath, 'profilenotification'],
          title: gettext('MENU.PROFILE_CONTACTS'),
          iconCss: 'in in-contact-card-16-filled',
        },
      ],
    },


  ].reduce((prev, cur) =>  {
    if (cur.namespaces && cur.namespaces.includes(namespace)) {
      let children = [];
      if (Array.isArray(cur.children)) {
        children = (cur.children as Array<any>).filter(child => child.namespaces && child.namespaces.includes(namespace));
      }
      prev.push({...cur, children});
    }
    return prev;
  }, [])
);
